import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import React, { useCallback, useDeferredValue, useEffect, useLayoutEffect, useMemo, useReducer, useRef, useState, } from 'react';
import { Flex } from '@magnetic/flex';
import { getBgColorByStatus, getBorderColorByStatus, STATUS_COLOR_MAP, POIS_MAP, POI_TYPES, POI_TYPES_ORIGINAL, getFloorShortNameByNumber, } from '../../util/index';
import { SwitchFloorPopup } from '../switch-floor-popup';
import { useTranslation } from 'react-i18next';
import { store } from '../../../../../store/store';
import { setRoomDetailsPopUp, getAllRooms, getAllDesks, getPOIS, getResetWidgets, getSmartRooms, setRoomSearchPopUp, } from '../../../../../store/uislice';
import { useDispatch, useSelector } from 'react-redux';
import { closeRoomDetailsPopup } from '../room-details-popup';
import { getFloorAnalytics, getRoomAnalytics, getLocation, getContext, getSelectedLocation, setSelectedLocation, } from '../../../redux/spaces-slice';
import Checked from '../../../../../assets/svgs/checked';
import Minus from '../../../../../assets/svgs/minus';
import People from '../../../../../assets/svgs/people';
import Plus from '../../../../../assets/svgs/plus';
import SearchSVG from '../../../../../assets/svgs/search';
import ListSVG from '../../../../../assets/images/list.svg';
import { startDirections } from '../map/directions';
import { invokeRichMapMethod } from '../map/rich-map';
import { createShowOccupancyPredicateForFloor, resolveShowPathFinding, } from '../../util/show-path-finding';
import { isHiddenOnKiosk } from '../../util/show-on-kiosk';
import { resolveWhereAmIFloor } from '../../util/where-am-i';
import { resolveSpaceTags } from '../../util/space-tags';
import { fuzzySearch } from '../../../../../utils/fuzzy-search';
import { selectLocalizedCountLabel } from '../../../../../utils/locale-format';
import { AVAILABILITY_FILTER_VALUES, DEFAULT_FILTERS, DURATION_AVAILABILITY_VALUES, FLOOR_FILTER_VALUES, filterReducer, getFiltersCount, } from './filter-state';
// "All Day" is treated as a fixed 12-hour (720 minute) free window rather than
// "free until midnight". A room qualifies when its analytics `freeUntil` is at
// least this many minutes (inclusive), independent of the current time of day.
const ALL_DAY_MINUTES = 720;
// Keep tag ordering consistent everywhere it is rendered. `localeCompare`
// with a case-insensitive comparison gives users the expected A-Z order while
// the final comparison keeps ordering deterministic for labels that differ
// only by case.
const sortTagsAlphabetically = (tags) => [...tags].sort((left, right) => left.localeCompare(right, undefined, { sensitivity: 'base' }) ||
    left.localeCompare(right));
const Modal = styled.div `
  background-color: #000;
  height: 100vh;
  opacity: 1;
  position: fixed;
  z-index: 9999999999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.7);
  display: flex !important;
`;
const ModalContent = styled.div ``;
const Text = styled(Flex) `
  font-size: ${(props) => props.fontSize};
  color: ${(props) => props.color};
  background: ${(props) => props.background};
  padding: ${(props) => props.padding};
  margin: ${(props) => props.margin};
  border-radius: ${(props) => props.borderRadius};
  white-space: nowrap;
  font-family: 'Sora', sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.2;
`;
const SearchBarContainer = styled(Flex) `
  width: 99.4vw;
`;
const SearchBar = styled(Flex) `
  background: #1f2226;
  height: fit-content;
  width: 54.8vw;
  min-width: fit-content;
  border-radius: 0.6vw;
  padding: 0.8vw;
  margin-top: 10vw;
`;
const ResultsCountContainer = styled.div `
  padding: 0.6vw 2vw;
`;
const HeaderRowContainer = styled.div `
  padding: 0vw 2vw;
`;
const HeaderRow = styled(Flex) `
  font-size: 0.8vw;
  color: #8f9092;
  width: 40vw;
`;
const Search = styled.input `
  background: #393d42;
  border: none;
  min-height: 3.4vw;
  color: white;
  font-size: 1.2vw;
  -webkit-appearance: none;
  &:focus {
    outline: none;
  }
  border-radius: 0.4vw;
  width: 100%;
  text-indent: 2.8vw;
`;
const UtilButton = styled(Flex) `
  background: ${(props) => props.background};
  height: ${(props) => (props.height ? props.height : '3.2vw')};
  border-radius: 0.4vw;
  width: ${(props) => (props.width ? props.width : '6vw')};
  text-align: center;
  line-height: 3vw;
  margin-right: 0.8vw;
  cursor: pointer;
`;
const Line = styled(Flex) `
  background: ${(props) => props.background};
  width: 58.6vw;
  height: 2px;
  margin-top: 0.4vw;
`;
const DirectionsButton = styled.div `
  background: linear-gradient(180deg, #1d7ff3 0%, #113d7d 100%);
  height: 1.2vw;
  width: 3.8vw;
  min-width: fit-content;
  font-size: 0.72vw;
  padding: 0.4vw;
  border-radius: 0.4vw;
  text-align: center;
  margin-right: 0.8vw;
`;
const LocateButton = styled.div `
  background: linear-gradient(180deg, #2b2f34 0%, #000000 100%);
  height: 1.2vw;
  border-radius: 0.4vw;
  width: 3.8vw;
  font-size: 0.72vw;
  padding: 0.4vw;
  text-align: center;
`;
const RoomItem = styled(Flex) `
  padding: 0.6vw;
  background: rgba(21, 23, 25, 1);
  width: 51.6vw;
  margin: 0.46vw 0vw 0.46vw 1.6vw;
  border-radius: 0.4vw;
`;
const AvailableCircle = styled(Flex) `
  width: 0.52vw;
  height: 0.52vw;
  margin-right: 0.375vw;
  background: ${(props) => getBgColorByStatus(props.availability)};
  border: 0.1vw solid ${(props) => getBorderColorByStatus(props.availability)};
  border-radius: 0.6875vw;
  margin: 0.6vw 0.2vw 0vw 0vw;
`;
const FilterViewContainer = styled(Flex) `
  padding: 1vw;
`;
const Circle = styled(Flex) `
  height: 1.25vw;
  width: 1.25vw;
  margin: 0vw 0.125vw;
  border-radius: 1.25vw;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const TagsContainer = styled.div `
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(7vw, 1fr));
  gap: 0.6vw 0.8vw;
  margin: 1vw 0vw;
  /* Show ~4 rows, then scroll the rest. Row = 1.6vw item + 0.6vw gap. */
  max-height: 8.2vw;
  overflow-y: auto;
  padding-right: 0.4vw;

  /* Subtle themed scrollbar */
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;

  &::-webkit-scrollbar {
    width: 0.35vw;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 0.4vw;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.32);
  }
`;
const TagItem = styled.label `
  display: flex;
  align-items: center;
  gap: 0.45vw;
  height: 1.6vw;
  cursor: pointer;
  user-select: none;
  overflow: hidden;
`;
const TagCheckboxInput = styled.input `
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
`;
const TagCheckbox = styled.span `
  flex: 0 0 auto;
  width: 0.95vw;
  height: 0.95vw;
  border-radius: 0.2vw;
  box-sizing: border-box;
  border: 0.1vw solid
    ${(props) => props.$checked ? 'rgba(0, 186, 235, 1)' : 'rgba(255, 255, 255, 0.4)'};
  background: ${(props) => props.$checked ? 'rgba(0, 186, 235, 1)' : 'transparent'};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s ease, border-color 0.15s ease;

  &::after {
    content: '';
    width: 0.24vw;
    height: 0.48vw;
    margin-top: -0.06vw;
    border: solid #0b0b0f;
    border-width: 0 0.14vw 0.14vw 0;
    transform: rotate(45deg);
    opacity: ${(props) => (props.$checked ? 1 : 0)};
    transition: opacity 0.15s ease;
  }
`;
const TagLabelText = styled.span `
  font-size: 0.84vw;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const TagBar = styled(Flex) `
  width: 54.8vw;
  margin: 0.8vw auto;
  height: 1.8vw;
  overflow-x: auto;
  /* Keep horizontal scrolling but hide the scrollbar. */
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;
const Tag = styled.div `
  padding: 0.32vw 0.6vw;
  background: rgba(0, 0, 0, 1);
  border: 1px solid rgba(0, 186, 235, 1);
  border-radius: 1vw;
  color: white;
  font-size: 0.6vw;
  height: 1vw;
  margin: 0 0.4vw;
`;
const FilterCounter = styled.div `
  background: rgba(0, 188, 235, 1);
  border-radius: 0.72vw;
  min-width: 1.92vw;
  padding: 0.18vw 0vw;
  height: fit-content;
  line-height: 0.8vw;
  margin-top: 0.92vw;
  color: black;
`;
const FilterCounterWrap = styled.div `
  margin-left: 0.5vw;
`;
// Memoized search result row. Extracted so a scroll-driven parent re-render
// (which fires on every animation frame during a fast fling) does NOT rebuild
// every windowed row's subtree. With referentially-stable props (see the parent),
// rows that stay in the window skip re-render entirely, and the per-row
// path-finding resolution now runs only when a row actually renders instead of for
// every windowed row on every frame. The markup and behavior are byte-for-byte the
// same as the previous inline row.
const SearchResultRow = React.memo(function SearchResultRow({ room, tags, capacity, locationData, roomDrawingOnMap, hasWhereAmISource, t, onDirections, onLocate, }) {
    return (_jsx(RoomItem, Object.assign({ direction: "vertical" }, { children: _jsxs(Flex, { children: [_jsx(Text, Object.assign({ fontSize: "1vw", style: {
                        minWidth: '14vw',
                        maxWidth: '14vw',
                        lineHeight: '2vw',
                        overflow: 'hidden',
                    } }, { children: _jsx("span", Object.assign({ title: room.name, style: {
                            display: 'block',
                            width: '100%',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                        } }, { children: room.name })) })), _jsx(Flex, Object.assign({ style: { minWidth: '7.2vw', maxWidth: '7.2vw' } }, { children: tags && tags.length > 0 && (_jsx(Flex, Object.assign({ style: {
                            background: 'rgba(85, 85, 85, 0.57)',
                            padding: '0.4vw',
                            borderRadius: '0.8vw',
                            maxWidth: '5vw',
                            overflow: 'auto',
                            height: '0.8vw',
                        } }, { children: _jsx(Text, Object.assign({ fontSize: "0.6vw", style: { lineHeight: '0.8vw' } }, { children: tags.length === 1
                                ? tags[0]
                                : tags[0] + '+' + (tags.length - 1) })) }))) })), _jsxs(Text, Object.assign({ fontSize: "0.8vw", style: { minWidth: '7.2vw', lineHeight: '2vw' } }, { children: [t('floor.room-search-popup.floor'), ' ', getFloorShortNameByNumber(locationData, room.floorNumber)] })), _jsxs(Flex, { children: [_jsx(Text, Object.assign({ fontSize: "0.6vw", color: STATUS_COLOR_MAP[room.availability], style: { minWidth: '8.2vw', lineHeight: '2vw' } }, { children: (room.isPOI || room.showOccupancy !== false) && (_jsxs(_Fragment, { children: [!room.isPOI && (_jsx(AvailableCircle, { availability: room.availability })), room.isPOI
                                        ? room.availability
                                        : t(`floor.room-details-popup.${room.availability}`)] })) })), _jsx(Text, Object.assign({ fontSize: "0.8vw", color: "rgba(0, 188, 235, 1)", style: { minWidth: '4.4vw', lineHeight: '2vw' } }, { children: !room.isPOI && capacity })), _jsxs(Flex, Object.assign({ justify: POI_TYPES.includes(room.name) ||
                                !roomDrawingOnMap ||
                                !hasWhereAmISource
                                ? 'end'
                                : 'space-between', width: "10vw" }, { children: [!POI_TYPES.includes(room.name) &&
                                    roomDrawingOnMap &&
                                    hasWhereAmISource && ( // Hide directions for Group POIs and when where-am-I has no usable source
                                _jsx(DirectionsButton, Object.assign({ onClick: () => onDirections(room) }, { children: t('floor.directions') }))), _jsx(LocateButton, Object.assign({ onClick: () => onLocate(room) }, { children: t('floor.room-search-popup.locate') }))] }))] })] }) })));
});
function compareName(room1, room2) {
    const name1 = room1.name.toUpperCase();
    const name2 = room2.name.toUpperCase();
    let comparison = 0;
    if (name1 > name2) {
        comparison = 1;
    }
    else if (name1 < name2) {
        comparison = -1;
    }
    return comparison;
}
export const RoomSearchPopupNew = ({ onClose, }) => {
    var _a;
    const { t, i18n } = useTranslation();
    const globalDispatch = useDispatch();
    const floorLocationId = useSelector(getSelectedLocation);
    // ---------------------------------------------------------------------------
    // Live analytics streams are DEFERRED here.
    //
    // getAllRooms/getAllDesks/getFloorAnalytics/getSmartRooms/getPOIS all update on
    // every NATS analytics batch (up to once per animation frame in a busy tenant).
    // The big `rooms` memo below does an O(N log N) filter+sort AND rebuilds a fresh
    // object for every row ({...room, availability}). Those new identities defeat
    // the row memoization, so without deferral EVERY visible row would re-render on
    // EVERY analytics tick — on top of the scroll-driven window updates. During a
    // fast fling that saturates the main thread and the window can't paint, which is
    // the "grey" gap.
    //
    // useDeferredValue keeps the list rebuild at low (transition) priority: an
    // urgent scroll frame reuses the PREVIOUS analytics value (so the memos stay
    // cached and the row objects keep the same identity -> memo holds -> cheap
    // render), and React recomputes the list in a background render that yields to
    // scrolling and catches up when the fling settles. Availability still updates
    // continuously (sub-second) — it just no longer competes with the scroll.
    // ---------------------------------------------------------------------------
    const globalRoomsDataRaw = useSelector(getAllRooms);
    const globalRoomsData = useDeferredValue(globalRoomsDataRaw);
    const sortedRooms = useMemo(() => [...globalRoomsData].sort(compareName), [globalRoomsData]);
    // Map SDK baseline for desks (work-space features), mirroring how rooms come
    // from the map. Analytics only ENRICH availability below — they no longer gate
    // whether a desk is searchable.
    const globalDesksDataRaw = useSelector(getAllDesks);
    const globalDesksData = useDeferredValue(globalDesksDataRaw);
    const spaceAnalyticsRaw = useSelector(getRoomAnalytics);
    const spaceAnalytics = useDeferredValue(spaceAnalyticsRaw);
    const POISRaw = useSelector(getPOIS).POIS;
    const POIS = useDeferredValue(POISRaw);
    const [selectedName, setSelectedName] = useState('');
    const [selectedFloorNumber, setSelectedFloorNumber] = useState(null);
    const [selectedRichMapId, setSelectedRichMapId] = useState(null);
    // Unique feature id for the selected (other-floor) space, so the post-switch
    // focus targets the exact feature rather than the first richMapId match.
    const [selectedFid, setSelectedFid] = useState(null);
    const [searchInput, setSearchInput] = useState('');
    const [showSwitchFloorPopup, setShowSwitchFloorPopup] = useState(false);
    const [isPOISelected, setIsSelectedPOI] = useState(false);
    const resetWidgets = useSelector(getResetWidgets);
    const floorAnalyticsRaw = useSelector(getFloorAnalytics);
    const floorAnalytics = useDeferredValue(floorAnalyticsRaw);
    const locationData = useSelector(getLocation);
    const [isFilterViewOpen, setIsFilterViewOpen] = useState(false);
    const smartRoomsRaw = useSelector(getSmartRooms);
    const smartRooms = useDeferredValue(smartRoomsRaw);
    const smartRoomSet = useMemo(() => new Set(smartRooms), [smartRooms]);
    const deferredSearchInput = useDeferredValue(searchInput);
    const [draftFilters, dispatchFilters] = useReducer(filterReducer, DEFAULT_FILTERS);
    const [appliedFilters, setAppliedFilters] = useState(DEFAULT_FILTERS);
    // resetWidgets is a monotonic timestamp bumped by resetViewHandler each time a
    // reset happens; it only means "a reset JUST occurred" when it CHANGES. Guarding
    // on `resetWidgets > 0` (its old behavior) also fired on every fresh mount once
    // any reset had ever happened (e.g. after the 240s inactivity reset), which
    // closed the search popup the instant it opened — the "Search button bouncing"
    // customers saw. Track the last-seen value and only react to an actual change,
    // skipping the value captured at mount.
    const prevResetWidgetsRef = useRef(resetWidgets);
    useEffect(() => {
        if (resetWidgets === prevResetWidgetsRef.current)
            return;
        prevResetWidgetsRef.current = resetWidgets;
        setShowSwitchFloorPopup(false);
        setSelectedFloorNumber(null);
        setSelectedRichMapId(null);
        setIsSelectedPOI(false);
        setAppliedFilters(DEFAULT_FILTERS);
        dispatchFilters({ name: 'reset' });
        globalDispatch(setRoomSearchPopUp({ payload: false }));
    }, [globalDispatch, resetWidgets]);
    // Provide availability, capacity info to the rooms for which the info is available
    const { allTags, meetingRoomTags, deskTags, hotDesks, roomTagsMap, roomsAvailabilityMap, roomsCapacityMap, roomsFreeUntilMap, } = useMemo(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const roomsCapacityMapTemp = {};
        const roomsAvailabilityMapTemp = {};
        const roomsFreeUntilMapTemp = {};
        const hotDesksTemp = [];
        // Desk availability keyed by desk id (`${lvl}~${name}`), collected from
        // analytics. This mirrors roomsAvailabilityMap and is used to enrich the
        // map-derived desk baseline below (rather than being the desk list itself).
        const deskAvailabilityMapTemp = {};
        const statuses = ['available', 'booked', 'hold', 'noData', 'occupied'];
        const statusMap = {
            available: 'Available',
            booked: 'Booked',
            hold: 'Hold',
            noData: 'Unknown',
            occupied: 'Occupied',
        };
        for (const child of (locationData === null || locationData === void 0 ? void 0 : locationData.children) || []) {
            for (const room of ((child === null || child === void 0 ? void 0 : child.rooms) || [])) {
                roomsCapacityMapTemp[room.richMapId] = room.capacity || 'Unknown';
            }
        }
        for (const oneFloorAnalytics of Object.keys(floorAnalytics || {})) {
            const deskInfo = ((_b = (_a = floorAnalytics === null || floorAnalytics === void 0 ? void 0 : floorAnalytics[oneFloorAnalytics]) === null || _a === void 0 ? void 0 : _a.availabilityInfo) === null || _b === void 0 ? void 0 : _b.deskInfo) || {};
            const roomInfo = ((_d = (_c = floorAnalytics === null || floorAnalytics === void 0 ? void 0 : floorAnalytics[oneFloorAnalytics]) === null || _c === void 0 ? void 0 : _c.availabilityInfo) === null || _d === void 0 ? void 0 : _d.roomInfo) || {};
            const freeUntilInfo = (roomInfo === null || roomInfo === void 0 ? void 0 : roomInfo.freeUntil) || {};
            for (const status of statuses) {
                if (!(status in deskInfo))
                    continue;
                for (const desk of deskInfo[status]) {
                    deskAvailabilityMapTemp[desk] = statusMap[status];
                }
            }
            for (const status of statuses) {
                if (!(status in roomInfo))
                    continue;
                for (const room of roomInfo[status]) {
                    roomsAvailabilityMapTemp[room] = statusMap[status];
                }
            }
            for (const key of Object.keys(freeUntilInfo)) {
                const freeUntilValue = Number(freeUntilInfo[key]);
                if (Number.isFinite(freeUntilValue)) {
                    roomsFreeUntilMapTemp[key] = freeUntilValue;
                }
            }
        }
        // Desk list = union of the map SDK baseline (work-space features) and any
        // analytics-only desks, de-duplicated by key. The baseline makes desks
        // searchable as soon as the map loads (like rooms); analytics enrich
        // availability (default "Unknown" until a deskInfo message arrives). The
        // analytics fallback guarantees no desk that showed before this change can
        // disappear if it isn't present as a map feature.
        const seenDeskKeys = new Set();
        for (const desk of globalDesksData || []) {
            if (!(desk === null || desk === void 0 ? void 0 : desk.key) || seenDeskKeys.has(desk.key))
                continue;
            seenDeskKeys.add(desk.key);
            // A desk seats one person — capacity is always 1. Register it in the same
            // capacity map the list renders from so desks show "1" (rooms use their
            // own keys, so they're unaffected).
            roomsCapacityMapTemp[desk.key] = 1;
            hotDesksTemp.push({
                name: (_e = desk.name) !== null && _e !== void 0 ? _e : desk.key.split('~')[1],
                floorNumber: Number((_f = desk.floorNumber) !== null && _f !== void 0 ? _f : desk.key.split('~')[0]),
                availability: (_g = deskAvailabilityMapTemp[desk.key]) !== null && _g !== void 0 ? _g : 'Unknown',
                key: desk.key,
                capacity: 1,
                isPOI: false,
            });
        }
        for (const deskKey of Object.keys(deskAvailabilityMapTemp)) {
            if (seenDeskKeys.has(deskKey))
                continue;
            seenDeskKeys.add(deskKey);
            roomsCapacityMapTemp[deskKey] = 1;
            hotDesksTemp.push({
                name: deskKey.split('~')[1],
                floorNumber: Number(deskKey.split('~')[0]),
                availability: deskAvailabilityMapTemp[deskKey],
                key: deskKey,
                capacity: 1,
                isPOI: false,
            });
        }
        const deskIds = new Set(hotDesksTemp.map((desk) => desk.key));
        for (const [key, message] of Object.entries(spaceAnalytics !== null && spaceAnalytics !== void 0 ? spaceAnalytics : {})) {
            if (((_h = message === null || message === void 0 ? void 0 : message.level) === null || _h === void 0 ? void 0 : _h.toUpperCase()) === 'DESK') {
                deskIds.add(message.richMapId || key);
            }
        }
        const roomTagsMapTemp = resolveSpaceTags(locationData, spaceAnalytics, deskIds);
        const allTagsTemp = new Set(Object.values(roomTagsMapTemp).flat());
        const meetingRoomTagsTemp = new Set();
        const deskTagsTemp = new Set();
        for (const [id, tags] of Object.entries(roomTagsMapTemp)) {
            const target = deskIds.has(id) ? deskTagsTemp : meetingRoomTagsTemp;
            for (const tag of tags)
                target.add(tag);
        }
        return {
            allTags: sortTagsAlphabetically(Array.from(allTagsTemp)),
            meetingRoomTags: sortTagsAlphabetically(Array.from(meetingRoomTagsTemp)),
            deskTags: sortTagsAlphabetically(Array.from(deskTagsTemp)),
            hotDesks: hotDesksTemp,
            roomTagsMap: roomTagsMapTemp,
            roomsAvailabilityMap: roomsAvailabilityMapTemp,
            roomsCapacityMap: roomsCapacityMapTemp,
            roomsFreeUntilMap: roomsFreeUntilMapTemp,
        };
    }, [floorAnalytics, locationData, globalDesksData, spaceAnalytics]);
    const isLoading = !((_a = locationData === null || locationData === void 0 ? void 0 : locationData.children) === null || _a === void 0 ? void 0 : _a.length) ||
        (sortedRooms.length === 0 &&
            hotDesks.length === 0 &&
            Object.keys(POIS || {}).length === 0);
    const floorLocationData = locationData === null || locationData === void 0 ? void 0 : locationData.children.find((child) => child.id === floorLocationId);
    const currentFloor = Number(floorLocationData === null || floorLocationData === void 0 ? void 0 : floorLocationData.floorNumber);
    const contextInfo = useSelector(getContext);
    const isSingleFloorSignage = contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.floorNumber;
    // Floor-view signage: the same condition that hides the floor selector
    // (viewType === 'floor'). In this mode there is effectively one floor, so
    // "All Floors" is meaningless. This is the authoritative "single floor" signal
    // (a floor-view signage may not carry a truthy `floorNumber`).
    const isFloorViewSignage = (contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.viewType) === 'floor';
    // Search is pinned to the current floor when the signage is floor-locked —
    // either floor-view (selector hidden) or bound to a specific floorNumber.
    const isFloorLockedSignage = isFloorViewSignage || Boolean(isSingleFloorSignage);
    const isPathFindingEnabled = contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.isPathFindingEnabled;
    // Search Directions requires pathfinding; wayfinding alone only enables QR flows.
    const tenantPathDrawingEnabled = Boolean(isPathFindingEnabled);
    // Search lists rooms across floors, so path drawing must be resolved per the
    // destination room's floor via the hierarchical LH `showPathFinding` flag
    // (building -> floor). Only explicit booleans disable; absent/null inherit,
    // preserving existing behavior when the flag isn't set.
    const isPathDrawingEnabledForFloor = (floorNumber) => resolveShowPathFinding({
        location: locationData,
        floorNumber: Number(floorNumber),
        tenantPathDrawingEnabled,
    });
    // Precompute the path-drawing flag once per floor. The LH cascade only depends
    // on the floor number, so resolving it here (once per floor) turns each row's
    // lookup into an O(1) Map read instead of an O(floors) hierarchy scan. This
    // keeps every newly-entering row cheap during a fast fling.
    const pathDrawingByFloor = useMemo(() => {
        var _a;
        const map = new Map();
        const floors = (_a = locationData === null || locationData === void 0 ? void 0 : locationData.children) !== null && _a !== void 0 ? _a : [];
        for (const floor of floors) {
            const n = Number(floor === null || floor === void 0 ? void 0 : floor.floorNumber);
            if (Number.isFinite(n) && !map.has(n)) {
                map.set(n, resolveShowPathFinding({
                    location: locationData,
                    floorNumber: n,
                    tenantPathDrawingEnabled,
                }));
            }
        }
        return map;
    }, [locationData, tenantPathDrawingEnabled]);
    const resolvePathDrawingForRoom = useCallback((floorNumber) => {
        const n = Number(floorNumber);
        const cached = pathDrawingByFloor.get(n);
        if (cached !== undefined)
            return cached;
        // Floor not present in the LH children (rare) — fall back to the full
        // resolver so behavior is identical to before.
        return resolveShowPathFinding({
            location: locationData,
            floorNumber: n,
            tenantPathDrawingEnabled,
        });
    }, [pathDrawingByFloor, locationData, tenantPathDrawingEnabled]);
    const buildingName = contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.building;
    const tenantId = locationData === null || locationData === void 0 ? void 0 : locationData.tenant;
    const whereAmIFloor = resolveWhereAmIFloor(locationData, contextInfo);
    const deviceLocationId = whereAmIFloor === null || whereAmIFloor === void 0 ? void 0 : whereAmIFloor.id;
    const deviceFloorNumber = Number(whereAmIFloor === null || whereAmIFloor === void 0 ? void 0 : whereAmIFloor.floorNumber);
    const hasWhereAmISource = Boolean(whereAmIFloor);
    useEffect(() => closeRoomDetailsPopup(), []);
    const normalizedSearchInput = deferredSearchInput.trim();
    // Floors flagged `showOnKioskAndWebApp === false` are hidden from the pickers;
    // their features (rooms, desks, POIs) must likewise never surface in search
    // under ANY filter. Collect those floor numbers once and exclude everything on
    // them from the final result set below. Only an explicit `false` hides a
    // floor; absent/null/true keep today's behavior.
    const hiddenFloorNumbers = useMemo(() => {
        const set = new Set();
        for (const child of (locationData === null || locationData === void 0 ? void 0 : locationData.children) || []) {
            if (isHiddenOnKiosk(child)) {
                const floorNumber = Number(child === null || child === void 0 ? void 0 : child.floorNumber);
                if (Number.isFinite(floorNumber))
                    set.add(floorNumber);
            }
        }
        return set;
    }, [locationData]);
    const occupancyByFloor = useMemo(() => {
        var _a;
        const predicates = new Map();
        for (const floor of (_a = locationData === null || locationData === void 0 ? void 0 : locationData.children) !== null && _a !== void 0 ? _a : []) {
            const number = Number(floor.floorNumber);
            predicates.set(number, createShowOccupancyPredicateForFloor(locationData, number));
        }
        return predicates;
    }, [locationData]);
    const isOccupancyShown = useCallback((space) => {
        var _a;
        const floorNumber = Number(space.floorNumber);
        const predicate = (_a = occupancyByFloor.get(floorNumber)) !== null && _a !== void 0 ? _a : createShowOccupancyPredicateForFloor(locationData, floorNumber);
        return predicate(space.key);
    }, [locationData, occupancyByFloor]);
    const rooms = useMemo(() => {
        var _a, _b, _c, _d;
        const filteredRooms = [];
        const availabilityFilterValue = appliedFilters.availability;
        const isDurationAvailabilityFilterActive = DURATION_AVAILABILITY_VALUES.has(availabilityFilterValue);
        const minimumRequiredFreeUntil = availabilityFilterValue === AVAILABILITY_FILTER_VALUES.ALL_DAY
            ? ALL_DAY_MINUTES
            : Number(availabilityFilterValue);
        const matchesTag = (roomKey) => {
            if (appliedFilters.tags.length === 0) {
                return true;
            }
            const tags = roomTagsMap[roomKey] || [];
            return appliedFilters.tags.some((tag) => tags.includes(tag));
        };
        // "All" checked OR nothing checked (the cleared state) both mean "show every
        // space type". Selecting a specific box (Meeting Rooms / Desks) narrows to it.
        const noSpaceTypeSelected = !appliedFilters.all &&
            !appliedFilters.meetingRooms &&
            !appliedFilters.hotDesks;
        const includeAllSpaceTypes = appliedFilters.all || noSpaceTypeSelected;
        if (appliedFilters.meetingRooms || includeAllSpaceTypes) {
            for (const room of sortedRooms) {
                if (appliedFilters.smartRoom && !smartRoomSet.has(room.key))
                    continue;
                const showOccupancy = isOccupancyShown(room);
                const roomAvailability = showOccupancy
                    ? roomsAvailabilityMap[room.key] || room.availability
                    : 'Unknown';
                const roomCapacity = roomsCapacityMap[room.key];
                const normalizedCapacity = typeof roomCapacity === 'number'
                    ? roomCapacity
                    : Number(roomCapacity);
                if (Number.isFinite(normalizedCapacity)) {
                    // Known capacity: exclude when it can't seat the requested count.
                    if (appliedFilters.roomCapacity > normalizedCapacity) {
                        continue;
                    }
                }
                else if (appliedFilters.roomCapacity > 1) {
                    // Unknown capacity: at the default (1) show it, but once a capacity
                    // greater than 1 is requested, exclude it since we can't confirm it
                    // meets the requirement.
                    continue;
                }
                if (!matchesTag(room.key))
                    continue;
                if (isDurationAvailabilityFilterActive) {
                    if (roomAvailability !== 'Available') {
                        continue;
                    }
                    const freeUntilMinutes = roomsFreeUntilMap[room.key];
                    if (!Number.isFinite(minimumRequiredFreeUntil) ||
                        !Number.isFinite(freeUntilMinutes) ||
                        freeUntilMinutes < minimumRequiredFreeUntil) {
                        continue;
                    }
                }
                if (appliedFilters.thisFloor === FLOOR_FILTER_VALUES.THIS_FLOOR &&
                    room.floorNumber !== currentFloor) {
                    continue;
                }
                filteredRooms.push(Object.assign(Object.assign({}, room), { availability: roomAvailability, showOccupancy, isPOI: false }));
            }
        }
        if (!isDurationAvailabilityFilterActive &&
            // Desks seat one person (capacity 1), so any required capacity greater
            // than 1 excludes them all — mirrors the meeting-room capacity check
            // above. roomCapacity's minimum is 1, so this is a no-op at the default.
            appliedFilters.roomCapacity <= 1 &&
            // Desks are not smart rooms, so hide them when the smart-room filter is on.
            !appliedFilters.smartRoom &&
            (appliedFilters.hotDesks || includeAllSpaceTypes)) {
            for (const desk of hotDesks) {
                if (!matchesTag(desk.key))
                    continue;
                if (appliedFilters.thisFloor === FLOOR_FILTER_VALUES.THIS_FLOOR &&
                    desk.floorNumber !== currentFloor) {
                    continue;
                }
                const showOccupancy = isOccupancyShown(desk);
                filteredRooms.push(Object.assign(Object.assign({}, desk), { availability: showOccupancy ? desk.availability : 'Unknown', showOccupancy, isPOI: false }));
            }
        }
        if (!isDurationAvailabilityFilterActive &&
            // POIs have no meaningful capacity, so once a capacity greater than 1 is
            // requested they're excluded (same rule as desks). No-op at the default.
            appliedFilters.roomCapacity <= 1 &&
            // POIs are not smart rooms, so hide them when the smart-room filter is on.
            !appliedFilters.smartRoom &&
            // Tags are a room/desk-only attribute; POIs never carry tags, so once any
            // tag filter is active there can't be a matching POI — exclude them all.
            appliedFilters.tags.length === 0 &&
            includeAllSpaceTypes) {
            const flagMap = new Set();
            for (const type of POI_TYPES) {
                for (const POI of (POIS === null || POIS === void 0 ? void 0 : POIS[type]) || []) {
                    const poiFloorNumber = Number((_a = POI === null || POI === void 0 ? void 0 : POI.properties) === null || _a === void 0 ? void 0 : _a.lvl);
                    // Honor the "This Floor" scope for POIs too (rooms and desks above
                    // already do). Without this, "This Floor + All" leaked POIs from other
                    // floors (e.g. Floor 2's "221"/"222" while viewing Floor 1).
                    if (appliedFilters.thisFloor === FLOOR_FILTER_VALUES.THIS_FLOOR &&
                        poiFloorNumber !== currentFloor) {
                        continue;
                    }
                    const flagKey = `${type}-${poiFloorNumber}`;
                    if (!flagMap.has(flagKey)) {
                        filteredRooms.push({
                            name: type,
                            floorNumber: poiFloorNumber,
                            availability: '--',
                            key: '',
                            capacity: 0,
                            isPOI: true,
                        });
                        flagMap.add(flagKey);
                    }
                    if (((_b = POI === null || POI === void 0 ? void 0 : POI.properties) === null || _b === void 0 ? void 0 : _b.name) && ((_c = POI === null || POI === void 0 ? void 0 : POI.properties) === null || _c === void 0 ? void 0 : _c.lvl)) {
                        filteredRooms.push({
                            name: POI.properties.name,
                            floorNumber: Number(POI.properties.lvl),
                            availability: '--',
                            key: POI.id,
                            fid: (_d = POI === null || POI === void 0 ? void 0 : POI.properties) === null || _d === void 0 ? void 0 : _d.fid,
                            capacity: 0,
                            isPOI: true,
                        });
                    }
                }
            }
        }
        // Drop anything (room, desk, POI) that lives on a hidden floor, regardless
        // of the active filter or single/multi-floor mode.
        const visibleRooms = hiddenFloorNumbers.size === 0
            ? filteredRooms
            : filteredRooms.filter((room) => !hiddenFloorNumbers.has(Number(room.floorNumber)));
        const floorFilteredRooms = isFloorLockedSignage
            ? visibleRooms.filter((room) => Number(currentFloor) === room.floorNumber)
            : visibleRooms;
        if (normalizedSearchInput) {
            return fuzzySearch(floorFilteredRooms, normalizedSearchInput, [
                'name',
            ]).map(({ item }) => item);
        }
        // Default (no-query) list ordering: surface the CURRENT floor's spaces at
        // the top, then everything else, alphabetical within each group. With the
        // filter now defaulting to "All Floors", this keeps the most relevant
        // (current-floor) results visible first. When "This Floor" is active every
        // result is already on the current floor, so this is a no-op there.
        return floorFilteredRooms.sort((a, b) => {
            const aCurrent = Number(a.floorNumber) === Number(currentFloor) ? 0 : 1;
            const bCurrent = Number(b.floorNumber) === Number(currentFloor) ? 0 : 1;
            if (aCurrent !== bCurrent)
                return aCurrent - bCurrent;
            return compareName(a, b);
        });
    }, [
        POIS,
        appliedFilters,
        currentFloor,
        hiddenFloorNumbers,
        hotDesks,
        isFloorLockedSignage,
        isOccupancyShown,
        normalizedSearchInput,
        roomTagsMap,
        roomsAvailabilityMap,
        roomsCapacityMap,
        roomsFreeUntilMap,
        smartRoomSet,
        sortedRooms,
    ]);
    const activeFilterCount = useMemo(() => getFiltersCount(isFilterViewOpen ? draftFilters : appliedFilters), [appliedFilters, draftFilters, isFilterViewOpen]);
    // --- Results list: CSS content-visibility virtualization -----------------
    // The list renders EVERY match in normal flow, but each row wrapper carries
    // `content-visibility: auto`, so the BROWSER itself skips layout + paint for
    // the rows that are off-screen and renders them as they approach the viewport.
    //
    // Why not JS windowing: with JS windowing, the set of mounted rows is chosen by
    // React state that must be recomputed on the MAIN THREAD on every scroll frame.
    // Under CPU pressure (throttled devices / heavy analytics) the main thread is
    // exactly what's starved, so React commits the next window LATE — the compositor
    // has already scrolled past it and the empty spacer shows (the "grey"). With
    // content-visibility the rows already exist in the DOM; scrolling and revealing
    // them is handled by the browser's own rendering pipeline, so it does NOT depend
    // on a per-frame React render. That's the property that survives throttling.
    //
    // `contain-intrinsic-size` reserves each skipped row's height so the scrollbar
    // and scroll offsets are correct before a row is first rendered. Rows are a
    // uniform height, so we measure one on-screen row and reuse that height for all
    // rows. We seed it from a vw-based estimate so off-screen rows are skipped from
    // the very first render (no all-rows layout spike on open); the measured value
    // then refines it.
    const listScrollerRef = useRef(null);
    const measureRow0Ref = useRef(null);
    const [rowHeightPx, setRowHeightPx] = useState(() => typeof window !== 'undefined'
        ? Math.round((window.innerWidth / 100) * 3.2)
        : 44);
    // Measure a single rendered row (row 0 is always on-screen at the top) and use
    // its border-box height as every row's intrinsic size. Runs on list re-renders
    // (open / filter / deferred analytics), never on scroll, and converges after
    // one update since all rows share a height.
    useLayoutEffect(() => {
        const row0 = measureRow0Ref.current;
        if (!row0)
            return;
        const measured = row0.getBoundingClientRect().height;
        if (measured > 0 && Math.abs(measured - rowHeightPx) > 0.5) {
            setRowHeightPx(measured);
        }
    });
    const rowCvStyle = useMemo(() => ({
        contentVisibility: 'auto',
        // inline-size intrinsic 0 (block width fills the container), block-size
        // intrinsic = measured row height.
        containIntrinsicSize: `0 ${rowHeightPx}px`,
    }), [rowHeightPx]);
    // --- On-demand mount (infinite scroll) -----------------------------------
    // content-visibility makes SCROLLING cheap, but React still has to CREATE and
    // reconcile a fiber + DOM node for every row when it first renders. Each row is
    // ~a dozen styled(Flex) components, so mounting thousands at once — or in a
    // fixed background ramp — is a multi-second main-thread hit. Mounting all at
    // once stalls the OPEN; a background ramp just relocates the stall onto the
    // first scroll (the ramp is still churning the thread when the user scrolls).
    //
    // Instead we mount a small first batch (snappy open, and the thread goes idle
    // immediately so the first scroll is smooth) and grow ONLY as the user scrolls
    // near the end, driven by an IntersectionObserver on a sentinel just past the
    // last mounted row — not a timer and not a per-frame scroll handler. A generous
    // rootMargin prefetches the next batch before the user reaches it, so growth is
    // hidden. Already-mounted off-screen rows stay cheap via content-visibility.
    const INITIAL_MOUNT = 60; // comfortably more than one viewport of rows
    const MOUNT_BATCH = 150; // rows appended each time the sentinel is approached
    const [mountedCount, setMountedCount] = useState(INITIAL_MOUNT);
    const sentinelRef = useRef(null);
    // Restart from the top whenever the RESULT SET changes (new query / filters) so
    // a large new list doesn't mount all at once. Availability-only updates don't
    // change these inputs, so they never restart the mount.
    useEffect(() => {
        setMountedCount(INITIAL_MOUNT);
        // A changed result set is a fresh list; return the scroller to the top so
        // the first INITIAL_MOUNT rows are what the user sees (otherwise a stale
        // scroll offset could clamp them past the newly-shortened content).
        if (listScrollerRef.current)
            listScrollerRef.current.scrollTop = 0;
    }, [normalizedSearchInput, appliedFilters]);
    // Never render more rows than exist (a shrunk result set clamps immediately).
    const visibleMountCount = Math.min(mountedCount, rooms.length);
    // Grow when the sentinel (just past the last mounted row) approaches the
    // viewport. The observer is re-created whenever the mounted count changes so it
    // re-attaches to the sentinel's new position as the list grows.
    useEffect(() => {
        if (visibleMountCount >= rooms.length)
            return;
        const root = listScrollerRef.current;
        const sentinel = sentinelRef.current;
        if (!root || !sentinel || typeof IntersectionObserver === 'undefined') {
            return;
        }
        const io = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
                setMountedCount((count) => Math.min(count + MOUNT_BATCH, rooms.length));
            }
        }, { root, rootMargin: '1500px 0px' });
        io.observe(sentinel);
        return () => io.disconnect();
    }, [visibleMountCount, rooms.length]);
    const closeSearchPopup = useCallback(() => {
        closeRoomDetailsPopup();
        onClose();
    }, [onClose]);
    // Apply is a plain (urgent) update, NOT a useTransition. This component
    // subscribes to the live NATS analytics stream, so a low-priority transition
    // render stays "pending" for seconds — it keeps getting deferred behind the
    // continuous analytics churn — which is what showed "loading..." for 6-7s even
    // though applying is cheap. React auto-batches these setState calls into one
    // synchronous commit, and we only mount INITIAL_MOUNT rows, so it's fast.
    const applyFiltersAndClose = useCallback(() => {
        setAppliedFilters(draftFilters);
        setIsFilterViewOpen(false);
        // Re-open the list at the top with only INITIAL_MOUNT rows instead of
        // re-mounting however many the IntersectionObserver grew to while scrolling.
        setMountedCount(INITIAL_MOUNT);
    }, [draftFilters]);
    // Clear returns to the same canonical unfiltered state used on first load:
    // "All Rooms" selected and a badge count of 0. The search string is
    // intentionally preserved, so the complete result set remains narrowed only
    // by the current search term.
    const clearAllFiltersAndClose = useCallback(() => {
        dispatchFilters({ name: 'reset' });
        setAppliedFilters(DEFAULT_FILTERS);
        setIsFilterViewOpen(false);
        // Same reason as applyFiltersAndClose: re-open the list at the top with
        // only INITIAL_MOUNT rows instead of re-mounting a grown count.
        setMountedCount(INITIAL_MOUNT);
    }, []);
    const goClickHandler = (room) => {
        const setupSwitchFloorPopup = (name, floorNumber, richMapId, fid) => {
            setShowSwitchFloorPopup(true);
            setSelectedName(name);
            setSelectedFloorNumber(String(floorNumber));
            setSelectedRichMapId(richMapId);
            setSelectedFid(fid !== null && fid !== void 0 ? fid : null);
        };
        if ((room === null || room === void 0 ? void 0 : room.isPOI) && POI_TYPES.includes(room.name)) {
            // POI Group
            closeRoomDetailsPopup();
            if (room.floorNumber === currentFloor) {
                closeSearchPopup();
                setTimeout(() => {
                    if (invokeRichMapMethod('reset')) {
                        for (const type of POI_TYPES_ORIGINAL) {
                            invokeRichMapMethod('updatePoiSelection', type, true);
                        }
                        invokeRichMapMethod('updatePoiSelection', POIS_MAP[room.name], false);
                    }
                }, 180);
            }
            else {
                // Different floor pop up
                setupSwitchFloorPopup(room.name, room.floorNumber, room.key, room.fid);
            }
            return;
        }
        // If it's a room (webex / non-webex) or an individual POI
        // In current floor
        if (room.floorNumber === currentFloor) {
            closeSearchPopup();
            // closeSearchPopup() -> closeRoomDetailsPopup() schedules rMap.exitNavigation()
            // at +200ms, whose `else if (#focusedFeatureWithMarker)` branch would strip
            // the focus pin. So drop the pin AFTER that teardown runs (mirrors the
            // switch-floor path, which focuses at +1000ms and works). skipMarker=false
            // shows the pin; the SDK still self-guards with `!#pathFeatureCollection`,
            // so an active route is never disturbed.
            setTimeout(() => {
                // Focus the exact feature via its unique `fid` (falls back to the
                // richMapId key). The popup still opens by richMapId.
                invokeRichMapMethod('focusFeature', room.fid || room.key, false);
                store.dispatch(setRoomDetailsPopUp({ payload: room.key }));
            }, 260);
        }
        // Not in current floor
        else {
            setupSwitchFloorPopup(room.name, room.floorNumber, room.key, room.fid);
        }
    };
    const resetSwitchFloorPopupState = () => {
        setShowSwitchFloorPopup(false);
        setSelectedName('');
        setSelectedFloorNumber(null);
        setSelectedRichMapId(null);
        setSelectedFid(null);
        setIsSelectedPOI(false);
    };
    const cancelSwitchFloorPopup = () => {
        // Dismissing the "room is on a different floor" prompt should only close the
        // prompt and return to the (still-open) search list — it must NOT close the
        // search itself. Confirming ("Go to Floor N") still closes search since it
        // navigates away to reveal the map/room-details.
        resetSwitchFloorPopupState();
    };
    const confirmSwitchFloorPopup = () => {
        const richMapId = selectedRichMapId;
        const fid = selectedFid;
        const poiName = selectedName;
        resetSwitchFloorPopupState();
        closeSearchPopup();
        if (poiName && POI_TYPES.includes(poiName)) {
            // If it's a group POI, no focusing on a single feature, no showing room details popup
            setTimeout(() => {
                if (invokeRichMapMethod('reset')) {
                    for (const type of POI_TYPES_ORIGINAL) {
                        invokeRichMapMethod('updatePoiSelection', type, true);
                    }
                    invokeRichMapMethod('updatePoiSelection', POIS_MAP[poiName], false);
                }
            }, 180);
            return;
        }
        setTimeout(() => {
            // skipMarker=false -> show the focus pin on the located room (same SDK
            // guard against active routes applies, so directions is unaffected).
            // Focus by unique `fid` when available so same-named spaces on the target
            // floor don't zoom to the wrong one; falls back to the richMapId.
            invokeRichMapMethod('focusFeature', fid || richMapId, false);
            store.dispatch(setRoomDetailsPopUp({ payload: richMapId }));
        }, 1000);
    };
    const handleFilterViewToggle = useCallback(() => {
        if (isFilterViewOpen) {
            applyFiltersAndClose();
            return;
        }
        dispatchFilters({ name: 'replace', value: appliedFilters });
        setIsFilterViewOpen(true);
    }, [appliedFilters, applyFiltersAndClose, isFilterViewOpen]);
    const CAPACITY_MAX = 20;
    const CAPACITY_MIN = 1;
    const PlusHandler = () => {
        if (draftFilters.roomCapacity < CAPACITY_MAX)
            dispatchFilters({
                name: 'roomCapacity',
                value: draftFilters.roomCapacity + 1,
            });
    };
    const MinusHandler = () => {
        if (draftFilters.roomCapacity > CAPACITY_MIN)
            dispatchFilters({
                name: 'roomCapacity',
                value: draftFilters.roomCapacity - 1,
            });
    };
    const floorToggleValues = [
        {
            label: t('floor.room-search-popup.all-floors'),
            value: FLOOR_FILTER_VALUES.ALL_FLOORS,
        },
        {
            label: t('floor.room-search-popup.this-floor'),
            value: FLOOR_FILTER_VALUES.THIS_FLOOR,
        },
    ];
    // Floor-locked signage (floor-view, i.e. the floor selector is hidden, or a
    // signage bound to a specific floorNumber) has only one floor, so "All Floors"
    // is meaningless — lock the toggle to "This Floor" and disable "All Floors".
    // The results memo hard-filters to the current floor under the same condition
    // (`isFloorLockedSignage`), so the UI lock and the actual filtering agree.
    // Multi-floor building-view signage is unaffected.
    const floorFilterLocked = isFloorLockedSignage;
    const effectiveFloorFilter = floorFilterLocked
        ? FLOOR_FILTER_VALUES.THIS_FLOOR
        : draftFilters.thisFloor;
    const availabilityOptions = [
        {
            value: AVAILABILITY_FILTER_VALUES.ANY,
            label: t('floor.room-search-popup.any'),
        },
        { value: '30', label: '30min +' },
        { value: '60', label: '60min +' },
        { value: '90', label: '90min +' },
        {
            value: AVAILABILITY_FILTER_VALUES.ALL_DAY,
            label: t('floor.room-search-popup.all-data'),
        },
    ];
    const checkBoxes = [
        t('floor.room-search-popup.all'),
        t('floor.room-search-popup.meeting-rooms'),
        // Display label only — the underlying filter (hotDesks) is unchanged.
        t('floor.show-on-map-toggle.desks'),
    ];
    const checkBoxValues = [
        draftFilters.all,
        draftFilters.meetingRooms,
        draftFilters.hotDesks,
    ];
    const getSelectableTags = (filters) => {
        if (filters.all || filters.meetingRooms === filters.hotDesks) {
            return allTags;
        }
        return filters.meetingRooms ? meetingRoomTags : deskTags;
    };
    const updateSpaceTypeFilters = (changes) => {
        const allowedTags = getSelectableTags(Object.assign(Object.assign({}, draftFilters), changes));
        dispatchFilters({
            name: 'merge',
            value: Object.assign(Object.assign({}, changes), { tags: draftFilters.tags.filter((tag) => allowedTags.includes(tag)) }),
        });
    };
    // "All" and the specific space-type checkboxes (Meeting Rooms / Desks) are
    // mutually exclusive: selecting a specific type clears "All", and selecting
    // "All" clears the specific types. Toggling the last specific type off simply
    // leaves nothing selected (badge 0), which the results memo treats as
    // "show everything".
    const checkBoxDisptatchers = [
        () => updateSpaceTypeFilters({
            all: !draftFilters.all,
            meetingRooms: false,
            hotDesks: false,
        }),
        () => updateSpaceTypeFilters({
            meetingRooms: !draftFilters.meetingRooms,
            all: false,
        }),
        () => updateSpaceTypeFilters({
            hotDesks: !draftFilters.hotDesks,
            all: false,
        }),
    ];
    const directionsClickHandler = (room) => {
        if (!hasWhereAmISource || !isPathDrawingEnabledForFloor(room.floorNumber)) {
            return;
        }
        // The directions button is only rendered when where-am-I provides a usable
        // source (see hasWhereAmISource), so we can go straight to path drawing.
        closeSearchPopup();
        window.requestAnimationFrame(() => {
            startDirections({
                currentFloorLocationId: floorLocationId,
                deviceFloorNumber,
                deviceLocationId,
                drawingOnMap: isPathDrawingEnabledForFloor(room.floorNumber),
                richMapId: room.key,
                roomFloorNumber: Number(room.floorNumber),
                roomName: room.name,
                tenantId,
            });
        });
    };
    // Stable identities for the row's click props so React.memo isn't defeated by a
    // fresh handler reference on every (scroll-driven) parent render. Refs always
    // point at the latest handler, so behavior is unchanged; only the wrapper
    // identity is pinned.
    const goClickHandlerRef = useRef(goClickHandler);
    goClickHandlerRef.current = goClickHandler;
    const directionsClickHandlerRef = useRef(directionsClickHandler);
    directionsClickHandlerRef.current = directionsClickHandler;
    const onLocateRow = useCallback((room) => goClickHandlerRef.current(room), []);
    const onDirectionsRow = useCallback((room) => directionsClickHandlerRef.current(room), []);
    return (_jsxs(Modal, { children: [showSwitchFloorPopup && (_jsx(SwitchFloorPopup, { name: selectedName, floorNumber: selectedFloorNumber, selectFloor: (selectedFloorId) => {
                    globalDispatch(setSelectedLocation(selectedFloorId));
                    confirmSwitchFloorPopup();
                }, onClose: cancelSwitchFloorPopup, isPOI: isPOISelected })), _jsxs(ModalContent, { children: [_jsx(SearchBarContainer, Object.assign({ justify: "center" }, { children: _jsxs(SearchBar, Object.assign({ justify: "space-between" }, { children: [_jsxs(Flex, Object.assign({ justify: "start", style: { width: '42vw', paddingLeft: '1.4vw' } }, { children: [_jsx("div", Object.assign({ style: {
                                                transform: 'scale(2.6)',
                                                marginTop: '1.8vw',
                                                marginRight: '-2vw',
                                            } }, { children: _jsx(SearchSVG, {}) })), _jsx(Search, { value: searchInput, onChange: (e) => setSearchInput(e.target.value), placeholder: `${t('floor.room-search-popup.search-across')} ${buildingName}`, autoFocus: true })] })), _jsxs(UtilButton, Object.assign({ style: { padding: '0vw 0.4vw' }, width: "fit-content", background: isFilterViewOpen
                                        ? 'linear-gradient(180deg, #000000 0%, #2b2f34 100%)'
                                        : 'linear-gradient(180deg, #2b2f34 0%, #000000 100%)', onClick: handleFilterViewToggle, justify: "space-around" }, { children: [_jsx("img", { src: ListSVG, style: {
                                                height: '1.2vw',
                                                marginTop: '0.8vw',
                                            } }), t('floor.room-search-popup.filter'), activeFilterCount > 0 && (_jsx(FilterCounterWrap, { children: _jsx(FilterCounter, { children: activeFilterCount }) }))] })), _jsx(UtilButton, Object.assign({ style: { padding: '0vw 0.4vw' }, width: "fit-content", minWidth: true, direction: "vertical", background: "linear-gradient(180deg, #2b2f34 0%, #000000 100%)", onClick: closeSearchPopup, id: "quit-search" }, { children: t('floor.room-search-popup.cancel') }))] })) })), _jsx(TagBar, { children: sortTagsAlphabetically(isFilterViewOpen ? draftFilters.tags : appliedFilters.tags).map((tag, idx) => (_jsx(Tag, { children: tag }, `${tag}-${idx}`))) }), _jsxs("div", Object.assign({ ref: listScrollerRef, style: {
                            width: '54.8vw',
                            border: '1px solid #343434',
                            background: '#1f2226',
                            margin: '1.2vw auto',
                            maxHeight: '58vh',
                            overflowY: 'scroll',
                            borderRadius: '0.6vw',
                        } }, { children: [isLoading && (_jsx("div", Object.assign({ style: {
                                    textAlign: 'center',
                                    fontSize: '1.6vw',
                                    padding: '1vw',
                                } }, { children: t('floor.room-finder.loading') }))), !isFilterViewOpen && !isLoading ? (_jsxs("div", { children: [_jsxs(ResultsCountContainer, { children: [_jsxs(Flex, { children: [_jsxs(Text, Object.assign({ fontSize: "1.2vw" }, { children: [rooms.length, ' ', selectLocalizedCountLabel(rooms.length, i18n.resolvedLanguage || i18n.language, t('result'), t('results')), ' ', searchInput !== '' && t('for')] })), _jsxs(Text, Object.assign({ fontSize: "1.2vw", color: "rgba(0, 188, 235, 1)" }, { children: ["\u00A0", searchInput] }))] }), _jsx(Line, { background: "#343434", width: "100%" })] }), _jsxs(HeaderRowContainer, { children: [_jsxs(HeaderRow, { children: [_jsx(Text, Object.assign({ margin: "0vw 12vw 0vw 0vw" }, { children: t('floor.room-search-popup.title') })), _jsx(Text, Object.assign({ margin: "0vw 6vw 0vw 0vw" }, { children: t('floor.room-search-popup.tags') })), _jsx(Text, Object.assign({ margin: "0vw 3.8vw 0vw 0vw" }, { children: t('floor.room-search-popup.location') })), _jsx(Text, Object.assign({ margin: "0vw 3.8vw 0vw 0vw" }, { children: t('floor.room-search-popup.availability') })), _jsx(Text, Object.assign({ margin: "0vw 4.2vw 0vw 0vw" }, { children: t('floor.room-search-popup.capacity') }))] }), _jsx(Line, { background: "#343434", width: "100%" })] }), _jsxs("div", { children: [rooms.slice(0, visibleMountCount).map((room, index) => {
                                                const roomKey = room.key || `${room.name}-${room.floorNumber}`;
                                                // Every row is in normal flow; `content-visibility: auto`
                                                // lets the browser skip off-screen rows' layout/paint. Row 0
                                                // is measured (it's always on-screen) to size the intrinsic
                                                // placeholder for the skipped rows.
                                                return (_jsx("div", Object.assign({ ref: index === 0 ? measureRow0Ref : undefined, style: rowCvStyle }, { children: _jsx(SearchResultRow, { room: room, tags: roomTagsMap[room.key], capacity: roomsCapacityMap[room.key], locationData: locationData, roomDrawingOnMap: resolvePathDrawingForRoom(room.floorNumber), hasWhereAmISource: hasWhereAmISource, t: t, onDirections: onDirectionsRow, onLocate: onLocateRow }) }), roomKey));
                                            }), visibleMountCount < rooms.length && (_jsx("div", { ref: sentinelRef, style: { height: '1px', width: '100%' }, "aria-hidden": "true" }))] })] })) : (!isLoading && (_jsxs(FilterViewContainer, Object.assign({ direction: "vertical" }, { children: [_jsxs(Text, { children: [t('floor.room-search-popup.filter-by'), " :"] }), _jsx(Line, { background: "#343434", width: "100%" }), _jsxs(Flex, Object.assign({ justify: "flex-start", style: {
                                            gap: '1.4vw',
                                            alignItems: 'flex-start',
                                        } }, { children: [_jsx("div", Object.assign({ style: {
                                                    marginTop: '0vw',
                                                    background: '#1f2226',
                                                    borderRadius: '0.8vw',
                                                    padding: '0.4vw',
                                                } }, { children: _jsx("div", Object.assign({ style: {
                                                        background: '#000000',
                                                        height: 'fit-content',
                                                        width: 'fit-content',
                                                        borderRadius: '0.6vw',
                                                        marginTop: '0.4vw',
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                    } }, { children: floorToggleValues.map((option, i) => {
                                                        const isAllFloorsOption = option.value === FLOOR_FILTER_VALUES.ALL_FLOORS;
                                                        // Only "All Floors" is disabled, and only for
                                                        // single-floor signage.
                                                        const optionDisabled = floorFilterLocked && isAllFloorsOption;
                                                        const isActive = option.value === effectiveFloorFilter;
                                                        return (_jsx("button", Object.assign({ disabled: optionDisabled, style: {
                                                                background: isActive
                                                                    ? 'linear-gradient(180deg, #1D7FF3 0%, #113D7D 100%)'
                                                                    : '#000000',
                                                                borderRadius: '0.48vw',
                                                                zIndex: '99999999',
                                                                cursor: optionDisabled
                                                                    ? 'not-allowed'
                                                                    : floorFilterLocked
                                                                        ? 'default'
                                                                        : 'pointer',
                                                                opacity: optionDisabled ? 0.4 : 1,
                                                                width: 'fit-content',
                                                                minWidth: '4vw',
                                                                textAlign: 'center',
                                                                fontSize: '0.64vw',
                                                                padding: '0.6vw',
                                                                lineHeight: '0.6vw',
                                                                whiteSpace: 'nowrap',
                                                                color: 'white',
                                                                border: 'none',
                                                                fontFamily: 'Sora',
                                                            }, onClick: () => {
                                                                // Single-floor: "This Floor" is already the
                                                                // fixed selection and "All Floors" is disabled,
                                                                // so no toggle is possible.
                                                                if (floorFilterLocked)
                                                                    return;
                                                                dispatchFilters({
                                                                    name: 'thisFloor',
                                                                    value: option.value,
                                                                });
                                                            } }, { children: option.label }), i));
                                                    }) })) })), checkBoxes.map((checkBox, i) => i <= 2 && (_jsxs(Flex, Object.assign({ style: { marginRight: '1vw', width: 'fit-content' }, justify: "space-between" }, { children: [_jsx("input", { type: "checkbox", checked: checkBoxValues[i], onChange: () => checkBoxDisptatchers[i]() }), _jsx(Text, Object.assign({ fontSize: "0.8vw", margin: "1vw 0vw 0vw 0.4vw" }, { children: checkBox }))] }), `${checkBox}-${i}`)))] })), _jsx(Line, { background: "#343434", width: "100%" }), _jsxs(Flex, Object.assign({ justify: "flex-start", style: {
                                            gap: '1.4vw',
                                            alignItems: 'flex-start',
                                        } }, { children: [_jsx("div", Object.assign({ style: {
                                                    marginTop: '0vw',
                                                    background: '#1f2226',
                                                    borderRadius: '0.8vw',
                                                    padding: '0.4vw',
                                                } }, { children: _jsx("div", Object.assign({ style: {
                                                        background: '#000000',
                                                        height: 'fit-content',
                                                        width: 'fit-content',
                                                        borderRadius: '0.6vw',
                                                        marginTop: '0.4vw',
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                    } }, { children: availabilityOptions.map((option, i) => (_jsx("button", Object.assign({ style: {
                                                            background: option.value === draftFilters.availability
                                                                ? 'linear-gradient(180deg, #1D7FF3 0%, #113D7D 100%)'
                                                                : '#000000',
                                                            borderRadius: '0.48vw',
                                                            zIndex: '99999999',
                                                            cursor: 'pointer',
                                                            width: '4vw',
                                                            textAlign: 'center',
                                                            fontSize: '0.64vw',
                                                            padding: '0.6vw',
                                                            lineHeight: '0.74vw',
                                                            whiteSpace: 'normal',
                                                            overflowWrap: 'break-word',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            color: 'white',
                                                            border: 'none',
                                                            fontFamily: 'Sora',
                                                        }, onClick: () => {
                                                            dispatchFilters({
                                                                name: 'availability',
                                                                value: option.value,
                                                            });
                                                        } }, { children: option.label }), i))) })) })), _jsxs("div", Object.assign({ style: {
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '0.7vw',
                                                    marginTop: '1vw',
                                                    flex: '0 0 auto',
                                                    marginLeft: '0.8vw',
                                                } }, { children: [_jsx(Text, Object.assign({ fontSize: "0.8vw", color: "#9e9ea2" }, { children: t('floor.room-finder.room-capacity') })), _jsxs("div", Object.assign({ style: {
                                                            borderRadius: '0.6vw',
                                                            padding: '0.6vw 0vw',
                                                            width: '10vw',
                                                            background: 'black',
                                                            marginTop: '-0.4vw',
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            height: '0.9vw',
                                                        } }, { children: [_jsx("button", Object.assign({ style: {
                                                                    zIndex: 99999999,
                                                                    background: 'none',
                                                                    border: 'none',
                                                                }, onClick: MinusHandler }, { children: _jsx(Minus, {}) })), _jsx(People, {}), _jsxs(Text, Object.assign({ fontSize: "0.8vw" }, { children: [draftFilters.roomCapacity, ' ', t('floor.room-finder.or-more')] })), _jsx("button", Object.assign({ style: {
                                                                    zIndex: 99999999,
                                                                    background: 'none',
                                                                    border: 'none',
                                                                }, onClick: PlusHandler }, { children: _jsx(Plus, {}) }))] }))] })), _jsxs(Flex, Object.assign({ style: {
                                                    flex: '1 1 0',
                                                    minWidth: 0,
                                                    alignItems: 'flex-start',
                                                    gap: '0.55vw',
                                                    marginLeft: '0.8vw',
                                                } }, { children: [_jsxs(Text, Object.assign({ fontSize: "0.8vw", margin: "1vw 0.4vw 0vw 0vw", color: "#9e9ea2", style: {
                                                            flex: '1 1 auto',
                                                            minWidth: 0,
                                                            whiteSpace: 'normal',
                                                            overflowWrap: 'break-word',
                                                        } }, { children: [t('floor.room-search-popup.is-a-smart-room'), " :"] })), _jsx("button", Object.assign({ style: {
                                                            width: '3.75vw',
                                                            height: 'fit-content',
                                                            marginTop: '0.52vw',
                                                            background: draftFilters.smartRoom
                                                                ? 'linear-gradient(180deg, #113d7d 0%, #1d7ff3 100%)'
                                                                : '#31363E',
                                                            borderRadius: '1.25vw',
                                                            alignItems: 'center',
                                                            cursor: 'pointer',
                                                            padding: '0.2vw 0vw',
                                                            display: 'flex',
                                                            border: 'none',
                                                            justifyContent: draftFilters.smartRoom
                                                                ? 'end'
                                                                : 'start',
                                                        }, onClick: () => {
                                                            dispatchFilters({
                                                                name: 'smartRoom',
                                                                value: !draftFilters.smartRoom,
                                                            });
                                                        } }, { children: _jsx(Circle, { children: _jsx(Checked, {}) }) }))] }))] })), _jsx(TagsContainer, { children: getSelectableTags(draftFilters).map((tag, i) => {
                                            const checked = draftFilters.tags.includes(tag);
                                            return (_jsxs(TagItem, Object.assign({ title: tag }, { children: [_jsx(TagCheckboxInput, { type: "checkbox", checked: checked, onChange: () => dispatchFilters({ name: 'tag', value: tag }) }), _jsx(TagCheckbox, { "$checked": checked }), _jsx(TagLabelText, { children: tag })] }), `${tag}-${i}`));
                                        }) }), _jsxs(Flex, Object.assign({ justify: "flex-end" }, { children: [_jsx(UtilButton, Object.assign({ direction: "vertical", background: "linear-gradient(180deg, #2b2f34 0%, #000000 100%)", minWidth: "fit-content", width: "8vw", height: "2.8vw", onClick: clearAllFiltersAndClose }, { children: _jsx(Text, Object.assign({ justify: "center", fontSize: "0.92vw", style: {
                                                        marginTop: '0.6vw',
                                                        padding: '0.2vw',
                                                    } }, { children: t('floor.room-search-popup.clear-all-filters') })) })), _jsx(UtilButton, Object.assign({ direction: "vertical", background: "linear-gradient(180deg, #1d7ff3 0%, #113d7d 100%)", minWidth: "fit-content", width: "8vw", height: "2.8vw", onClick: applyFiltersAndClose }, { children: _jsx(Text, Object.assign({ justify: "center", fontSize: "0.92vw", style: {
                                                        marginTop: '0.6vw',
                                                        padding: '0.2vw',
                                                    } }, { children: t('floor.room-search-popup.apply-filters') })) }))] }))] }))))] }))] })] }));
};
